import { ViewType } from "./types";

const BUCKETS: Record<ViewType, number> = {
  MONTHLY: 12,
  QUARTERLY: 8,
  ANNUALLY: Infinity,
};

export function getXAxisTickInterval(viewType: ViewType, bucketCount: number) {
  const LIMIT_BUCKTET = BUCKETS[viewType];

  // show every tick within one year, otherwise skip ticks to keep the axis readable
  if (bucketCount <= LIMIT_BUCKTET) return 0;

  // skip ticks beyond one year to keep the axis readable
  return Math.ceil(bucketCount / LIMIT_BUCKTET) - 1;
}
